"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.currency = currency;
exports["default"] = void 0;

var _numeral = _interopRequireDefault(require("numeral"));

var _CurrencyHelper = _interopRequireDefault(require("./CurrencyHelper"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function currency() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var skipDecimal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var negative = value < 0;
  var val = skipDecimal ? (0, _numeral["default"])(Math.abs(value)).format('0,0') : (0, _numeral["default"])(Math.abs(value)).format('0,0.00');
  var returnValue = val; // if(!value % 1 == 0) {
  //   returnValue = parseFloat(Math.round(value * 100) / 100).toFixed(2);
  // } else {
  // }
  // if(value % 1 == 0) {
  //   returnValue = parseInt(value, 10);
  // }

  if (symbol) {
    if (symbol === true) {
      returnValue = _CurrencyHelper["default"].getCurrencySymbol() + returnValue;
    } else {
      returnValue = _CurrencyHelper["default"].getCurrencySymbol(symbol) + returnValue;
    }
  }

  if (negative) {
    returnValue = '-' + returnValue;
  }

  return returnValue;
}

var _default = {
  currency: currency
};
exports["default"] = _default;